import React from "react"

const SkeletonLoader = ({ customClass = "" }) => {
  return <div className={`skeleton-loader w-100 ${customClass}`}></div>
}

export default SkeletonLoader
